export const getColor = (num) => {
  if (num === 'N/A') {
      return ({bg: '#E0E0E0', border: '#C6C6C6'})
  } else if (num > 10000) {
      return ({bg: '#F2FAF5', border: '#DFEDE3'})
  } else if (num > 1000) {
      return ({bg: '#FFECC9', border: '#FFCF72'})
  } else return ({bg: '#FFCFC9', border: '#D0867C'})
}